<base-wrapper
  [logo]="logo"
  [logoSmall]="logoSmall"
  [applicationSections]="sections"
  [userMenu]="userMenu"
></base-wrapper>
